import Swal from "sweetalert2";

export const showEditorSaveToast = (title) => Swal.fire({
  toast: true,
  position: "top-end",
  icon: "success",
  title,
  showConfirmButton: false,
  timer: 2200,
  timerProgressBar: true,
  didOpen: (popup) => {
    // Expanded Python editors sit above the regular page overlays.
    if (popup.parentElement) popup.parentElement.style.zIndex = "3000";
  },
});
